<template>
<modal
	size="medium"
	class="modal-qr-participant"
	:hide-footer="true"
	@close="close"
	v-if="show">
	<div slot="header">
		<h3>{{ $t('QR for the event') }}</h3>
	</div>
	<div slot="body" class="p-0">
		<div class="event-barcode">
			<QRCard :event="event" :participant="participant"></QRCard>
		</div>
	</div>
</modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';

const QRCard = () => import('@/components/QRCard.vue');

export default {
	name: 'ModalQRParticipant',
	components: {
		Modal,
		QRCard,
	},
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		event: {
			type: Object,
			default: () => null,
			required: true,
		},
		participant: {
			type: Object,
			default: () => null,
			required: true,
		},
	},
	data() {
		return {
		};
	},
	mounted() {
	},
	methods: {
		close() {
			this.$emit('close');
		},
	},
	computed: {
		...mapGetters({
		}),
	},
	watch: {
		show() {
		},
	},
};
</script>
